module.exports = __webpack_public_path__ + "images/86cf855add20e011928d795f745ab24d28eb8046b1ede4b951db57db8abfff90.svg";